import { useState } from "react";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import { handleErrorMessage, useEffectOnce, isUserAssociateEditor } from "../../../utils/Utils";
interface ToDoListServiceType {
  assignReviewers: any;
  decide: any;
  overdueReviewers: any;
  overdueAssociate: any;
  returnedToEditor: any;
  underReview: any;
}

export default function ToDoListService(): ToDoListServiceType {
  const { showMessage, authData, setBlockUI } = useAppContext();
  const { axiosGetEditorArticleList, axiosGetArticlesForAssociate }: ArticleControllerType = ArticleController();
  const [assignReviewers, setAssignReviewers] = useState(null);
  const [decide, setDecide] = useState(null);
  const [overdueReviewers, setOverdueReviewers] = useState(null);
  const [overdueAssociate, setOverdueAssociate] = useState(null);
  const [returnedToEditor, setReturnedToEditor] = useState(null);
  const [underReview, setUnderReview] = useState(null);

  useEffectOnce(() => {
    isUserAssociateEditor(authData) ? getArticlesForAssociate() : getEditorArticleList();
  });

  const getEditorArticleList = () => {
    setBlockUI(true);
    axiosGetEditorArticleList()
      .then((result: any) => {
        const { assignReivewers, decide, overdueReviewers, overdueAssociate } = result.data;
        setAssignReviewers(assignReivewers);
        setDecide(decide);
        setOverdueReviewers(overdueReviewers);
        setOverdueAssociate(overdueAssociate);
        setBlockUI(false);
      })
      .catch((error: any) => {
        setBlockUI(false);
        handleErrorMessage(showMessage, error);
      });
  };

  const getArticlesForAssociate = () => {
    setBlockUI(true);
    axiosGetArticlesForAssociate()
      .then((result: any) => {
        const { assignReivewers, decide, overdueReviewers, returnedToEditor, underReview } = result.data;
        setAssignReviewers(assignReivewers);
        setDecide(decide);
        setOverdueReviewers(overdueReviewers);
        setReturnedToEditor(returnedToEditor);
        setUnderReview(underReview);
        setBlockUI(false);
      })
      .catch((error: any) => {
        setBlockUI(false);
        handleErrorMessage(showMessage, error);
      });
  };

  return { assignReviewers, decide, overdueReviewers, overdueAssociate, returnedToEditor, underReview };
}
export type { ToDoListServiceType };
